'use client';

import { useEffect } from 'react';
import { RiErrorWarningFill } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  const { t } = useTranslation();
  useEffect(() => {}, [error]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-background">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto flex size-20 items-center justify-center rounded-full bg-destructive/10">
          <RiErrorWarningFill className="size-10 text-destructive" />
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">{t('errorPages.error.title')}</h1>
          <p className="text-sm text-muted-foreground">
            {t('errorPages.error.description')}
          </p>
        </div>

        <Button onClick={reset} size="lg" className="w-full sm:w-auto">
          {t('errorPages.error.retry')}
        </Button>
      </div>
    </main>
  );
}
